const page = `

{settings}
document.title: Kent Wisti
og.title: Kent Wisti
og.image: http://quickshot.imgix.net/opinionsbildaren-kent-wisti/Wisti_Hamn.png?w=1000&auto=format
og.twitterImage: http://quickshot.imgix.net/opinionsbildaren-kent-wisti/Wisti_Hamn.png?h=120&w=120&auto=format&fit=crop
og.description: När de karaktäristiska gultonade teckningarna - ofta ackompanjerade av träffsäkra, sarkastiska kommentarer - började flasha förbi på Twitter och Facebook, var det få som kände till att det var en präst från Skåne som stod bakom satiren.
og.url: http://pejl.svt.se/opinionsbildaren-kent-wisti
siteCatalyst.name: opinionsbildaren-kent-wisti
siteCatalyst.category: lyxartikel
{}
[+page]
{.div}
  style.position:relative
  style.backgroundColor: black
  style.color:white
  style.height: 100%;
  style.marginBottom: -18px;
  [.+content]
  
  
    {.div}
      style.minHeight:70vh
      style.position:relative
      style.paddingBottom:25px
      [.+content]
        {.div}
          style.position:relative
          style.width: 300px
          style.height:45px
          style.top:20px
          style.backgroundImage: url('http://quickshot.imgix.net/annika-beijbom/ob-1-rad-vit-ht_720.png')
          style.backgroundPositionY: 50%
          style.backgroundPositionX: 0%
          style.backgroundSize: cover
          [.+content]
          []
        {}
        
        luft:-50
          rubrik3: Kent Wisti
          
          {.video}
            id:12483766?autostart=true
            storlek:wide
          {}
          {.citat}    
            citat:Jesus själv var kanske världshistoriens största satiriker, och kanske i dag den mest underskattade
            cstyle.color:#ddd
          {}
               
      []
    {}
    
    
   
   
 
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-kent-wisti/Wisti_Hamn.png?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundRepeat: no-repeat
      style.backgroundPositionY: 30%
      style.backgroundPositionX: 60%
      style.backgroundSize: cover
      [.+content]

      []
    {}
    
    
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: SATIREN

            När de karaktäristiska gultonade teckningarna - ofta ackompanjerade av träffsäkra, sarkastiska kommentarer - började flasha förbi på Twitter och Facebook, var det få som kände till att det var en präst från Skåne som stod bakom satiren.
            
            På bara några år har Kent Wistis teckningar blivit ett internetfenomen.
            
            Själv har han gått från en relativt okänd tillvaro med 250 vänner på Facebook till över 70 000 följare.
          []
        {}
      []
    {}
    
    
    
    {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id:12483830
          storlek:wide
        {}
        {.citat}    
          citat:För mig är det ganska mycket en kul grej - flams och trams bara. Men jag har förstått att det betyder en hel del för en del människor
          cstyle.color:#ddd
        {}
      []
    {}
    

    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-kent-wisti/WistiBarnPippi.jpg?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundPositionY: 40%
      style.backgroundPositionX: 40%
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      [.+content]

      []
    {}
    
    
     {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: YRKESVALET

            Kent Wisti är uppväxt på den småländska landsbygden, i ett arbetarklasshem med socialdemokratiska värderingar.
            
            Som 12-åring gick han med i SSU. Men 19 år gammal kände han att det blev för mycket maktkamp och han lämnade politiken.
            
            Medan hans mamma jobbade natt som vårdbiträde var det pappans yrkesroll som ledde in Kent Wisti på konstnärsbanan. Att han ville bli präst visste han redan som treåring.
          []
        {}
      []
    {}
    
    
    
    {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id:12483930
          storlek:wide
        {}
        {.citat}    
          citat:Det var inte konstigare att det fanns en tryckpress hemma än att det fanns en brödrost i köket
          cstyle.color:#ddd
        {}
      []
    {}
    
    
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            Mellanrubrik: KONSTEN

            Tillsammans med författaren Maria Küchen är Kent Wisti aktuell med konstutställningen KYSS, som anordnas i universitetskyrkans regi.
            
            Idén har sitt ursprung i Kent Wistis vilja att markera mot den patriarkala könsmaktsordningen i samhället och i kyrkan.
            
            Utställningen består av 15 erotiska bilder med text ur Höga Visan.
          []
        {}
      []
    {}
    
    
    
    {.bild}
    storlek:portrait
    fil:opinionsbildaren-kent-wisti/WistiKyss1.jpg
    bildtext: I en pelare av rök, omvänd av myrra kommer, kommer och kommer bortom tid, genom tiderna. Vem är han som kommer ur öknen, är hon han den det du jag vi? (Från KYSS)
    capstyle.background: #222
    capstyle.color: #fff
    capstyle.padding: 8px 12px
    {}
   
    
    
    
    luft:100
    
    
    {.bild}
    storlek:portrait
    fil:opinionsbildaren-kent-wisti/WistiKyss3.jpg
    bildtext: Fånga rävarna åt oss, de små rävarna, allt detta djupa glupande ljuva duvor vid strömmande vatten, allt detta hårda, knoppar som öppnar sig (Från KYSS) 
    capstyle.background: #222
    capstyle.color: #fff
    capstyle.padding: 8px 12px
    {}
    
    
    
    luft:100
    
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
            mellanrubrik: FRISPRÅKIGHETEN
          
            2012 anordnade Kent Wisti och universitetskyrkan ett annat uppseendeväckande event i St Johanneskyrkan i Malmö. Han bjöd in bland andra komikern Magnus Betnér, författaren och teologie doktorn Ann Heberlein samt biskop emeritus Lennart Koskinen för att ”roasta” Gud.
            
            En “roast” går ut på att håna och häckla föremålet för ”roasten”, i detta fall Gud. Fast det görs givetvis med kärlek, förklarar Kent Wisti.
            
            Idén föddes ur en av Wistis absoluta favoritlåtar, ”Häng Gud” av Ebba Grön, där raderna bland annat lyder ”Gud är fascist, Gud är rasist”.
            
            Men trots sin frispråkighet om allt från feminism till Sverigedemokraterna har Wisti aldrig drabbats av näthat.
          []
        {}
      []
    {}
    
    
    
     {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id:12483970
          storlek:wide
        {}

      []
    {}
    
    
    
    
    {.div}
        style.backgroundColor: #eee
        style.color:#111
        style.maxWidth: 600px
        style.padding: 1px 12px
        style.margin: 24px auto 0
        [.+content]
           mellanrubrik: OM KENT WISTI
           
          {.bild}
            fil:opinionsbildaren-kent-wisti/Wisti_Bibliotek.jpg
            storlek:m
          {}
          
          [Namn:] Kent Magnus Wisti.
          
          [Född:] 8 november 1971 i Älmhult.
          
          [Gör]: Universitetspräst, satiriker, bildkonstnär.
          
          [Bosatt:] I Lund
          
          [Familj:] Fru och tre barn.
          
          [Har gjort:] Tusentals satirteckningar som fått stor spridning på sociala medier. Släppt boken ”I det här jävla landet” som samlar de bästa.
          
          Roastat Gud tillsammans med Magnus Betnér, Ann Heberlein och Lennart Koskinen 2012.
          
          Aktuell med: Med utställningen "Kyss", som tolkar bibelns Höga Visan i text och bild (tillsammans med Maria Küchen).
          
          luft:
        []
      {}
      
      
      
    
    
    luft:200
    
    rubrik5:Reporter: Valeria Helander
    rubrik5:Fotograf: Åke Wehrling
    rubrik5:[SVT Opinion | http://www.svt.se/opinion/12516028 | white | target:_self  ]
    
    {.sharebuttons}
    title: Kent Wisti
    url: http://pejl.svt.se/opinionsbildaren-kent-wisti/
    {}
       
    luft:100
   
  []
{}



[]
`;

export default page;

/*

 {.div}
 style.minHeight:100vh
 style.paddingTop:20%
 [.+content]

 []
 {}

 */



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/opinionsbildaren-kent-wisti.js
 **/